module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 75);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/variable");

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

module.exports = require("@tencent/tvf-jsapi");

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

module.exports = require("@tencent/iwan-biz-helper");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-athena/lib/helper");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 75:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(7);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/helper"
var helper_ = __webpack_require__(3);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(2);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(0);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@tencent/txv-utils"
var txv_utils_ = __webpack_require__(1);

// CONCATENATED MODULE: ./src/bridge/commons/app.js


function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var common = {
  check: function check() {
    return window.TenvideoJSBridge;
  },
  // 等待全局对象TenvideoJSBridge创建
  ready: function ready() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              if (common.check()) {
                resolve();
                return;
              }
              document.addEventListener('onTenvideoJSBridgeReady', resolve);
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  // 调用app指定的api
  callJSBridge: function callJSBridge(strMethod, params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return common.ready();
          case 2:
            return _context2.abrupt("return", new Promise(function (resolve) {
              window.TenvideoJSBridge.invoke(strMethod, params, function (ret) {
                resolve(common.parse(ret));
              });
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  // 关闭h5
  close: function close() {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this.callJSBridge('close');
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  // 判断当前客户端版本是否支持指定JS接口
  checkApi: function checkApi() {
    var _arguments = arguments,
      _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var params, res;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
            _context4.next = 3;
            return _this2.callJSBridge('checkApi', {
              apiList: params
            });
          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", res);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  // 获取设备信息
  getDeviceInfo: function getDeviceInfo() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var res;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!common.deviceInfoData) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return", Object(txv_utils_["deepcopy"])(common.deviceInfoData));
          case 2:
            _context5.next = 4;
            return common.callJSBridge('getDeviceInfo');
          case 4:
            res = _context5.sent;
            if (!res.errCode) {
              common.deviceInfoData = Object(txv_utils_["deepcopy"])(res);
            }
            return _context5.abrupt("return", res);
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  register3rdAppDownloadListener: function register3rdAppDownloadListener(params) {
    var _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var res;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _this3.callJSBridge('register3rdAppDownloadListener', params);
          case 2:
            res = _context6.sent;
            return _context6.abrupt("return", res);
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  // 打开app
  launch3rdApp: function launch3rdApp(params) {
    var _this4 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      var res;
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _this4.callJSBridge('launch3rdApp', params);
          case 2:
            res = _context7.sent;
            return _context7.abrupt("return", res);
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  // 下载 或 安装app
  download3rdApp: function download3rdApp(params) {
    var _this5 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      var res;
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _this5.callJSBridge('download3rdApp', params);
          case 2:
            res = _context8.sent;
            return _context8.abrupt("return", res);
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  },
  // 暂停下载第三方app
  pauseDownload3rdApp: function pauseDownload3rdApp(params) {
    var _this6 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      var res;
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _this6.callJSBridge('pauseDowload3rdApp', params);
          case 2:
            res = _context9.sent;
            return _context9.abrupt("return", res);
          case 4:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  // 取消下载第三方app
  cancelDownload3rdApp: function cancelDownload3rdApp(params) {
    var _this7 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      var res;
      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _this7.callJSBridge('cancelDowload3rdApp', params);
          case 2:
            res = _context10.sent;
            return _context10.abrupt("return", res);
          case 4:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }))();
  },
  // 删除下载第三方app
  deleteDownload3rdAppTask: function deleteDownload3rdAppTask(params) {
    var _this8 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee11() {
      var res;
      return regenerator_default.a.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _this8.callJSBridge('deleteDownload3rdAppTask', params);
          case 2:
            res = _context11.sent;
            return _context11.abrupt("return", res);
          case 4:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }))();
  },
  // check下载状态
  checkDownload3rdAppState: function checkDownload3rdAppState(params) {
    var _this9 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      var checkParams, res;
      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            checkParams = _objectSpread({}, params);
            if (!('needCheckVersion' in params)) {
              Object.assign(checkParams, {
                needCheckVersion: true
              });
            }
            _context12.next = 4;
            return _this9.callJSBridge('checkDowload3rdAppState', checkParams);
          case 4:
            res = _context12.sent;
            return _context12.abrupt("return", res);
          case 6:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }))();
  },
  openUrl: function openUrl() {
    var _arguments2 = arguments,
      _this10 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee13() {
      var params, apiParams, res;
      return regenerator_default.a.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            params = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {
              url: ''
            };
            apiParams = {};
            if (Object(txv_utils_["isString"])(params)) {
              apiParams.url = params;
            } else {
              apiParams = params;
            }
            _context13.next = 5;
            return _this10.callJSBridge('openUrl', apiParams);
          case 5:
            res = _context13.sent;
            return _context13.abrupt("return", res);
          case 7:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }))();
  },
  actionLogin: function actionLogin() {
    var _arguments3 = arguments,
      _this11 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee14() {
      var params, res;
      return regenerator_default.a.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            params = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {};
            _context14.next = 3;
            return _this11.callJSBridge('actionLogin', params);
          case 3:
            res = _context14.sent;
            return _context14.abrupt("return", res);
          case 5:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }))();
  },
  login: function login() {
    var _arguments4 = arguments,
      _this12 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee15() {
      var params, res;
      return regenerator_default.a.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            params = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {
              type: 'tv'
            };
            _context15.next = 3;
            return _this12.actionLogin(_objectSpread({
              type: 'tv'
            }, params));
          case 3:
            res = _context15.sent;
            return _context15.abrupt("return", res);
          case 5:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }))();
  },
  logout: function logout() {
    var _arguments5 = arguments,
      _this13 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee16() {
      var params, res;
      return regenerator_default.a.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            params = _arguments5.length > 0 && _arguments5[0] !== undefined ? _arguments5[0] : {
              needBack: false
            };
            _context16.next = 3;
            return _this13.callJSBridge('logout', params);
          case 3:
            res = _context16.sent;
            return _context16.abrupt("return", res);
          case 5:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }))();
  },
  /**
   * 格式化返回结果为统一格式
   * @param {*} ret
   */
  parse: function parse(res) {
    var ret = res;
    if (!ret || !Object(txv_utils_["isString"])(ret)) {
      return ret;
    }
    try {
      ret = decodeURIComponent(ret);
    } catch (e) {}
    try {
      ret = JSON.parse(ret);
      ret.errCode = Number(ret.errCode);
    } catch (e) {
      ret = {
        errCode: 9,
        errMsg: 'parse error',
        result: {}
      };
    }
    return ret;
  },
  get3rdAppInfo: function get3rdAppInfo() {
    var _arguments6 = arguments,
      _this14 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee17() {
      var params, res;
      return regenerator_default.a.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            params = _arguments6.length > 0 && _arguments6[0] !== undefined ? _arguments6[0] : {
              packageName: ''
            };
            _context17.next = 3;
            return _this14.callJSBridge('get3rdAppInfo', params);
          case 3:
            res = _context17.sent;
            return _context17.abrupt("return", res);
          case 5:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }))();
  }
};
/* harmony default export */ var app = (common);
// CONCATENATED MODULE: ./src/bridge/commons/video.js





var video_common = {
  check: function check() {
    return window.TenvideoJSBridge;
  },
  // 等待全局对象TenvideoJSBridge创建
  ready: function ready() {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              if (_this.check()) {
                resolve();
                return;
              }
              document.addEventListener('onTenvideoJSBridgeReady', resolve);
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * 添加监听 app 事件方法
   * @param { String } method
   * @param { Function } callback
   */
  on: function on(method, callback) {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var methodStr;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            methodStr = "".concat(method, "Callback");
            if (!Object(txv_utils_["isArray"])(_this2[methodStr])) {
              _this2[methodStr] = [];
            }
            _this2[methodStr].push(callback);
            _context2.next = 5;
            return _this2.ready();
          case 5:
            window.TenvideoJSBridge.on(method, function (ret) {
              _this2[methodStr].forEach(function (cb) {
                cb && cb(_this2.parse(ret));
              });
            });
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  // 添加桌面icon
  addShortcut: function addShortcut(params) {
    var _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this3.callJSBridge('addShortcut', params);
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  // 复制到剪切板  string
  copyToClipBoard: function copyToClipBoard(str) {
    var _this4 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var res;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this4.callJSBridge('copyToClipBoard', {
              content: str
            });
          case 2:
            res = _context4.sent;
            return _context4.abrupt("return", res);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  // 获取App相关信息
  getAppInfo: function getAppInfo() {
    var _this5 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var res;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (!_this5.appInfoData) {
              _context5.next = 2;
              break;
            }
            return _context5.abrupt("return", Object(txv_utils_["deepcopy"])(_this5.appInfoData));
          case 2:
            _context5.next = 4;
            return _this5.callJSBridge('getAppInfo');
          case 4:
            res = _context5.sent;
            if (!res.errCode) {
              _this5.appInfoData = Object(txv_utils_["deepcopy"])(res);
            }
            return _context5.abrupt("return", res);
          case 7:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  openView: function openView() {
    var _arguments = arguments,
      _this6 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var params, res;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {
              url: ''
            };
            _context6.next = 3;
            return _this6.callJSBridge('openView', params);
          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", res);
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  // 拉起操作面板
  openToolsDialog: function openToolsDialog() {
    var _this7 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      var res;
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _this7.callJSBridge('openToolsDialog');
          case 2:
            res = _context7.sent;
            return _context7.abrupt("return", res);
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  /**
   * 获取网络信息
   */
  getNetworkState: function getNetworkState() {
    var _this8 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      var res;
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _this8.callJSBridge('getNetworkState', null);
          case 2:
            res = _context8.sent;
            return _context8.abrupt("return", res);
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  },
  /**
   * 获取当前主登录账号的cookie
   * 返回结果：res.result: {cookie: "uin=xx", type: "qq"}
   */
  getMainCookie: function getMainCookie() {
    var _this9 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      var ret, result, type, cookie, cookieObj;
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _this9.callJSBridge('getMainCookie');
          case 2:
            ret = _context9.sent;
            if (!ret.errCode) {
              result = ret.result;
              type = result.type, cookie = result.cookie;
              cookieObj = Object(txv_utils_["strToJson"])(cookie, ';');
              if (type === 'qq') {
                // 互联qq 和 ptlogin两种类型
                result.cookie = {
                  luin: cookieObj.luin,
                  uin: cookieObj.uin,
                  skey: cookieObj.skey,
                  lskey: cookieObj.lskey,
                  appid: cookieObj.vqq_appid,
                  openid: cookieObj.vqq_openid,
                  access_token: cookieObj.vqq_access_token
                };
              } else if (type === 'wx') {
                result.cookie = {
                  appid: cookieObj.appid,
                  openid: cookieObj.openid,
                  access_token: cookieObj.access_token
                };
              }
            }
            return _context9.abrupt("return", ret);
          case 5:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  // 设置More菜单
  setMoreInfo: function setMoreInfo(params) {
    var _this10 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      var res;
      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return _this10.callJSBridge('setMoreInfo', params);
          case 2:
            res = _context10.sent;
            return _context10.abrupt("return", res);
          case 4:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }))();
  },
  /**
   * 根据值获取storate
   * @param {*} key
   */
  formatStorage: function formatStorage(res, key) {
    var storage = {};
    if (res[key]) {
      storage = res[key];
    } else if (res.result && res.result[key]) {
      storage = res.result[key];
    }
    return storage;
  },
  // 获取本地存储 参数：key
  getNativeStorage: function getNativeStorage(key) {
    var _this11 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee11() {
      var res, storage;
      return regenerator_default.a.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return _this11.callJSBridge('getNativeStorage', {
              key: [key]
            });
          case 2:
            res = _context11.sent;
            storage = _this11.formatStorage(res, key);
            try {
              storage = JSON.parse(storage);
            } catch (error) {}

            // 判断是否过期
            if (Date.now() >= storage.age) {
              storage = {};
            }
            return _context11.abrupt("return", storage.value);
          case 7:
          case "end":
            return _context11.stop();
        }
      }, _callee11);
    }))();
  },
  /**
   * 设置本地存储 {"key9":"九","key8":"八"}
   * @param {*} key
   * @param {*} value
   * @param {*} age 默认过期时间 5年
   */
  setNativeStorage: function setNativeStorage(key, value) {
    var _arguments2 = arguments,
      _this12 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee12() {
      var age, storage, obj, res;
      return regenerator_default.a.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            age = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : 5 * 12 * 30 * 24 * 60 * 60 * 1000;
            storage = {
              value: value,
              age: Date.now() + age
            };
            obj = defineProperty_default()({}, key, JSON.stringify(storage));
            _context12.next = 5;
            return _this12.callJSBridge('setNativeStorage', obj);
          case 5:
            res = _context12.sent;
            return _context12.abrupt("return", res);
          case 7:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }))();
  },
  // 获取下载中的app列表
  getDownload3rdAppList: function getDownload3rdAppList(params) {
    var _this13 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee13() {
      var res;
      return regenerator_default.a.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return _this13.callJSBridge('getDownload3rdAppList', params);
          case 2:
            res = _context13.sent;
            return _context13.abrupt("return", res);
          case 4:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }))();
  },
  onShareFinish: function onShareFinish() {
    var _this14 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee14() {
      return regenerator_default.a.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return _this14.ready();
          case 2:
            return _context14.abrupt("return", new Promise(function (resolve) {
              window.TenvideoJSBridge.on('onShareFinish', function (ret) {
                resolve(_this14.parse(ret));
              });
            }));
          case 3:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }))();
  },
  onActionLoginFinish: function onActionLoginFinish() {
    var _this15 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee15() {
      return regenerator_default.a.wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return _this15.ready();
          case 2:
            return _context15.abrupt("return", new Promise(function (resolve) {
              window.TenvideoJSBridge.on('onActionLoginFinish', function (ret) {
                resolve(_this15.parse(ret));
              });
              window.TenvideoJSBridge.on('actionLoginFinish', function (ret) {
                resolve(_this15.parse(ret));
              });
            }));
          case 3:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }))();
  },
  onActionLogoutFinish: function onActionLogoutFinish() {
    var _this16 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee16() {
      return regenerator_default.a.wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return _this16.ready();
          case 2:
            return _context16.abrupt("return", new Promise(function (resolve) {
              window.TenvideoJSBridge.on('onActionLogoutFinish', function (ret) {
                resolve(_this16.parse(ret));
              });
              window.TenvideoJSBridge.on('actionLogoutFinish', function (ret) {
                resolve(_this16.parse(ret));
              });
            }));
          case 3:
          case "end":
            return _context16.stop();
        }
      }, _callee16);
    }))();
  },
  getInstallState: function getInstallState(config) {
    var _this17 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee17() {
      var packageName, packageUrl, res, _ref, _ref$result, result, installed;
      return regenerator_default.a.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return _this17.ready();
          case 2:
            packageName = config.packageName, packageUrl = config.packageUrl;
            _context17.next = 5;
            return _this17.callJSBridge('isInstalled', {
              pkgName: packageName,
              pkgUrl: packageUrl
            });
          case 5:
            res = _context17.sent;
            _ref = res || {}, _ref$result = _ref.result, result = _ref$result === void 0 ? {} : _ref$result;
            installed = result.installed;
            return _context17.abrupt("return", installed);
          case 9:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }))();
  },
  wakeApp: function wakeApp(opts, onSuccess, onFail) {
    var _this18 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee18() {
      var _opts$timeout, timeout, os, _opts$os, packageName, packageUrl, t;
      return regenerator_default.a.wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _this18.ready();
          case 2:
            _opts$timeout = opts.timeout, timeout = _opts$timeout === void 0 ? 3000 : _opts$timeout;
            os = Object(helper_["getPhoneSystem"])();
            _opts$os = opts[os], packageName = _opts$os.packageName, packageUrl = _opts$os.packageUrl;
            _this18.launch3rdApp({
              pkgName: packageName,
              pkgUrl: packageUrl
            });
            t = setTimeout(function () {
              onFail && onFail();
            }, timeout);
            window.onblur = function () {
              clearTimeout(t);
              onSuccess && onSuccess();
            };
          case 8:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }))();
  }
};
/* harmony default export */ var video = (video_common);
// CONCATENATED MODULE: ./src/bridge/libs/lite.js



function lite_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function lite_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? lite_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : lite_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 腾讯视频 极速版本 jsapi
 */


var api = lite_objectSpread(lite_objectSpread(lite_objectSpread({}, app), video), {}, {
  /**
   * 关闭h5
   */
  closeH5: function closeH5() {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.callJSBridge('closeH5');
          case 2:
            res = _context.sent;
            return _context.abrupt("return", res);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  hideH5: function hideH5() {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var res;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this2.callJSBridge('hideH5');
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  showH5: function showH5() {
    var _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this3.callJSBridge('showH5');
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  /**
   * @param {*} params
   *  dialog_title_image_url: '', //分享弹窗标题图片 可不传
      dialog_title_text: '', //分享弹窗标题
      auto_dismiss: 1, //1:分享后自动关闭 0:不自动关闭 、不传的话默认是1
      //分享的内容信息
      title: customtitle,
      subTitle: '',
      singleTitle: '',
      content: '',
      contentTail: '',
      imageUrl: '',
      url: '',
      //上报信息
      report: {
          'mod_id': '具体业务场景下的取值'
      }
    */
  showShareDialog: function showShareDialog(params) {
    var _this4 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var options, res;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            options = lite_objectSpread({
              dialog_title_image_url: '',
              dialog_title_text: '',
              auto_dismiss: 1,
              // 分享的内容信息
              title: '',
              subTitle: '',
              singleTitle: '',
              content: '',
              contentTail: '',
              imageUrl: '',
              url: ''
            }, params);
            _context4.next = 3;
            return _this4.callJSBridge('showShareDialog', options);
          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", res);
          case 5:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  toast: function toast(params) {
    var _this5 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var res;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this5.callJSBridge('toast', params);
          case 2:
            res = _context5.sent;
            return _context5.abrupt("return", res);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  /**
   * 切换横竖屏
   */
  setRequestedOrientation: function setRequestedOrientation() {
    var _arguments = arguments,
      _this6 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var params, res;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
            _context6.next = 3;
            return _this6.callJSBridge('setRequestedOrientation', params);
          case 3:
            res = _context6.sent;
            return _context6.abrupt("return", res);
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  // 获取当前用户不同类型账号的用户信息
  getUserInfo: function getUserInfo() {
    var _arguments2 = arguments,
      _this7 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      var params, res;
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            params = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : '';
            _context7.next = 3;
            return _this7.callJSBridge('getUserInfo', {
              type: params
            });
          case 3:
            res = _context7.sent;
            return _context7.abrupt("return", res);
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }
});
/* harmony default export */ var lite = (api);
// CONCATENATED MODULE: ./src/bridge/libs/tenvideo.js



function tenvideo_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function tenvideo_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? tenvideo_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : tenvideo_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 腾讯视频jsapi
 */


var tenvideo_api = tenvideo_objectSpread(tenvideo_objectSpread(tenvideo_objectSpread({}, app), video), {}, {
  // 获取当前用户不同类型账号的用户信息
  getUserInfo: function getUserInfo() {
    var _arguments = arguments,
      _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var params, res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : '';
            _context.next = 3;
            return _this.callJSBridge('getUserInfo', {
              type: params
            });
          case 3:
            res = _context.sent;
            return _context.abrupt("return", res);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  // 自动安装检查
  autoInstallAction: function autoInstallAction(params) {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var res;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this2.callJSBridge('autoInstallAction', {
              actionType: params
            });
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /*
     * 获取视频vip信息
     */
  getPayVip: function getPayVip() {
    var _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this3.callJSBridge('getPayVip');
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  getMainLoginMethod: function getMainLoginMethod() {
    var _this4 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var ret, _ret$result, result, getMainLoginType, type;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this4.checkApi(['getMainLoginType']);
          case 2:
            ret = _context4.sent;
            _ret$result = ret.result, result = _ret$result === void 0 ? {} : _ret$result;
            getMainLoginType = result.getMainLoginType;
            type = getMainLoginType ? 'getMainLoginType' : 'getMainCookie';
            return _context4.abrupt("return", type);
          case 7:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  /**
   * getMainLoginType: 当前主登录状态，目前"qq"、"wx"两种以及未登录
   * @param callback
   */
  getMainLoginType: function getMainLoginType() {
    var _this5 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var method, res;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this5.getMainLoginMethod();
          case 2:
            method = _context5.sent;
            _context5.next = 5;
            return _this5.callJSBridge(method);
          case 5:
            res = _context5.sent;
            if (method === 'getMainCookie') {
              res = {
                errCode: 0,
                result: res.result.type
              };
            }
            return _context5.abrupt("return", res);
          case 8:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  /**
   * 获取当前push通道开关的状态.
   * @returns {Promise<>}
   */
  getPushSwitch: function getPushSwitch() {
    var _this6 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var res;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _this6.callJSBridge('getPushSwitch');
          case 2:
            res = _context6.sent;
            return _context6.abrupt("return", res);
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  /**
   * push通道开关未开启时，拉起引导用户打开push通道开关的页面.
   * @returns {Promise<>}
   */
  openPushSwitch: function openPushSwitch() {
    var _this7 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      var res;
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _this7.callJSBridge('openPushSwitch');
          case 2:
            res = _context7.sent;
            return _context7.abrupt("return", res);
          case 4:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  // 分享本地图片
  shareLocalImage: function shareLocalImage(params) {
    var _this8 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      var res;
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _this8.callJSBridge('shareLocalImage', params);
          case 2:
            res = _context8.sent;
            return _context8.abrupt("return", res);
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  },
  setShare: function setShare(params, onShare, onShareSuccess) {
    var _this9 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      var data;
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _this9.ready();
          case 2:
            data = tenvideo_objectSpread({
              shareInfo: {
                title: params.title,
                subTitle: params.desc,
                singleTitle: params.singleTitle,
                content: params.title,
                contentTail: params.desc,
                imageUrl: params.img,
                url: params.link,
                style: 1,
                picList: []
              }
            }, params);
            _this9.onShare = onShare;
            _this9.onShareSuccess = onShareSuccess;
            _context9.next = 7;
            return _this9.setMoreInfo(data);
          case 7:
            _this9.shareCallback();
          case 8:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  shareCallback: function shareCallback() {
    var _this10 = this;
    window.TenvideoJSBridge.on('onToolsDialogShow', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this10.onShare && _this10.onShare(res);
    });

    // 分享成功
    window.TenvideoJSBridge.on('onShareFinish', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this10$parse = _this10.parse(res),
        _this10$parse$errCode = _this10$parse.errCode,
        errCode = _this10$parse$errCode === void 0 ? '' : _this10$parse$errCode;
      if (Number(errCode) === 0) {
        _this10.onShareSuccess && _this10.onShareSuccess(res);
      }
    });
  }
});
/* harmony default export */ var tenvideo = (tenvideo_api);
// EXTERNAL MODULE: external "@tencent/tvf-jsapi"
var tvf_jsapi_ = __webpack_require__(18);
var tvf_jsapi_default = /*#__PURE__*/__webpack_require__.n(tvf_jsapi_);

// CONCATENATED MODULE: ./src/bridge/libs/weishi.js



function weishi_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function weishi_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? weishi_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : weishi_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 微视jsapi
 * 使用tvf-jsapi
 */


var weishi_api = weishi_objectSpread(weishi_objectSpread({}, app), {}, {
  // 调用app指定的api
  callJSBridge: function callJSBridge(strMethod, params) {
    return tvf_jsapi_default.a.invoke(strMethod, params);
  },
  on: function on() {
    var _tvfJsApi$on;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_tvfJsApi$on = tvf_jsapi_default.a.on).call.apply(_tvfJsApi$on, [tvf_jsapi_default.a].concat(args));
  },
  // 获取设备信息
  getDeviceInfo: function getDeviceInfo() {
    return tvf_jsapi_default.a.invoke('getDeviceInfo');
  },
  login: function login() {
    return tvf_jsapi_default.a.invoke('actionLogin');
  },
  logout: function logout() {
    return tvf_jsapi_default.a.invoke('logout', {
      dismiss: false
    });
  },
  getMainCookie: function getMainCookie() {
    return tvf_jsapi_default.a.invoke('getMainCookie');
  },
  // 纠正拼写。暂停下载第三方app
  pauseDownload3rdApp: function pauseDownload3rdApp(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return tvf_jsapi_default.a.invoke('pauseDownload3rdApp', params);
          case 2:
            res = _context.sent;
            return _context.abrupt("return", res);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  // 纠正拼写。取消下载第三方app
  cancelDownload3rdApp: function cancelDownload3rdApp(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var res;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return tvf_jsapi_default.a.invoke('cancelDownload3rdApp', params);
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  // 纠正拼写。check下载状态
  checkDownload3rdAppState: function checkDownload3rdAppState(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return tvf_jsapi_default.a.invoke('checkDownload3rdAppState', params);
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  getDownload3rdAppList: function getDownload3rdAppList() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", {
              result: []
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  setMoreInfo: function setMoreInfo(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", tvf_jsapi_default.a.invoke('setMoreInfo', params));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  setShare: function setShare(params, onShare, onShareSuccess) {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var data;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            data = weishi_objectSpread({
              shareInfo: {
                title: params.title,
                subTitle: params.desc,
                singleTitle: params.singleTitle,
                content: params.title,
                contentTail: params.desc,
                imageUrl: params.img,
                url: params.link,
                style: 1,
                picList: []
              }
            }, params);
            _this.onShare = onShare;
            _this.onShareSuccess = onShareSuccess;
            _context6.next = 5;
            return _this.setMoreInfo(data);
          case 5:
            _this.shareCallback();
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  shareCallback: function shareCallback() {
    var _this2 = this;
    tvf_jsapi_default.a.on('onToolsDialogShow', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this2.onShare && _this2.onShare(res);
    });
    tvf_jsapi_default.a.on('onShareFinish', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this2$parse = _this2.parse(res),
        _this2$parse$errCode = _this2$parse.errCode,
        errCode = _this2$parse$errCode === void 0 ? '' : _this2$parse$errCode;
      if (Number(errCode) === 0) {
        _this2.onShareSuccess && _this2.onShareSuccess(res);
      }
    });
  },
  openToolsDialog: function openToolsDialog(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", tvf_jsapi_default.a.invoke('openToolsDialog', params));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }
});
/* harmony default export */ var weishi = (weishi_api);
// CONCATENATED MODULE: ./src/bridge/libs/sports.js



function sports_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function sports_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? sports_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : sports_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 体育jsapi
 * 使用tvf-jsapi
 */


var sports_api = sports_objectSpread(sports_objectSpread({}, app), {}, {
  // 调用app指定的api
  callJSBridge: function callJSBridge(strMethod, params) {
    return tvf_jsapi_default.a.invoke(strMethod, params);
  },
  on: function on() {
    var _tvfJsApi$on;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_tvfJsApi$on = tvf_jsapi_default.a.on).call.apply(_tvfJsApi$on, [tvf_jsapi_default.a].concat(args));
  },
  // 获取设备信息
  getDeviceInfo: function getDeviceInfo() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", {
              result: {}
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  getMainCookie: function getMainCookie() {
    return tvf_jsapi_default.a.invoke('getMainCookie');
  },
  // 纠正拼写。暂停下载第三方app
  pauseDownload3rdApp: function pauseDownload3rdApp(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var res;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return tvf_jsapi_default.a.invoke('pauseDownload3rdApp', params);
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  // 纠正拼写。取消下载第三方app
  cancelDownload3rdApp: function cancelDownload3rdApp(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return tvf_jsapi_default.a.invoke('cancelDownload3rdApp', params);
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  // 纠正拼写。check下载状态
  checkDownload3rdAppState: function checkDownload3rdAppState(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var res;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return tvf_jsapi_default.a.invoke('checkDownload3rdAppState', params);
          case 2:
            res = _context4.sent;
            return _context4.abrupt("return", res);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  getDownload3rdAppList: function getDownload3rdAppList() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", {
              result: []
            });
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  setMoreInfo: function setMoreInfo(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", tvf_jsapi_default.a.invoke('setMoreInfo', params));
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  setShare: function setShare(params, onShare, onShareSuccess) {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      var data;
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            data = sports_objectSpread({
              shareInfo: {
                title: params.title,
                subTitle: params.desc,
                singleTitle: params.singleTitle,
                content: params.title,
                contentTail: params.desc,
                imageUrl: params.img,
                url: params.link,
                style: 1,
                picList: []
              }
            }, params);
            _this.onShare = onShare;
            _this.onShareSuccess = onShareSuccess;
            _context7.next = 5;
            return _this.setMoreInfo(data);
          case 5:
            _this.shareCallback();
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  shareCallback: function shareCallback() {
    var _this2 = this;
    tvf_jsapi_default.a.on('onToolsDialogShow', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this2.onShare && _this2.onShare(res);
    });
    tvf_jsapi_default.a.on('onShareFinish', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this2$parse = _this2.parse(res),
        _this2$parse$errCode = _this2$parse.errCode,
        errCode = _this2$parse$errCode === void 0 ? '' : _this2$parse$errCode;
      if (Number(errCode) === 0) {
        _this2.onShareSuccess && _this2.onShareSuccess(res);
      }
    });
  },
  openToolsDialog: function openToolsDialog(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", tvf_jsapi_default.a.invoke('openToolsDialog', params));
          case 1:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }
});
/* harmony default export */ var sports = (sports_api);
// CONCATENATED MODULE: ./src/bridge/libs/yyb.js



function yyb_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function yyb_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? yyb_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : yyb_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 应用宝jsapi
 * 使用tvf-jsapi
 */


var yyb_api = yyb_objectSpread(yyb_objectSpread({}, app), {}, {
  // 调用app指定的api
  callJSBridge: function callJSBridge(strMethod, params) {
    return tvf_jsapi_default.a.invoke(strMethod, params);
  },
  on: function on() {
    var _tvfJsApi$on;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_tvfJsApi$on = tvf_jsapi_default.a.on).call.apply(_tvfJsApi$on, [tvf_jsapi_default.a].concat(args));
  },
  // 获取设备信息
  getDeviceInfo: function getDeviceInfo() {
    return tvf_jsapi_default.a.invoke('getDeviceInfo');
  },
  login: function login() {
    return tvf_jsapi_default.a.invoke('actionLogin', {
      type: 'popup'
    });
  },
  logout: function logout() {
    return tvf_jsapi_default.a.invoke('logout');
  },
  getMainCookie: function getMainCookie() {
    return tvf_jsapi_default.a.invoke('getMainCookie');
  },
  // 纠正拼写。暂停下载第三方app
  pauseDownload3rdApp: function pauseDownload3rdApp(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return tvf_jsapi_default.a.invoke('pauseDownload3rdApp', params);
          case 2:
            res = _context.sent;
            return _context.abrupt("return", res);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  // 纠正拼写。取消下载第三方app
  cancelDownload3rdApp: function cancelDownload3rdApp(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var res;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return tvf_jsapi_default.a.invoke('cancelDownload3rdApp', params);
          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  // 纠正拼写。check下载状态
  checkDownload3rdAppState: function checkDownload3rdAppState(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var res;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return tvf_jsapi_default.a.invoke('checkDownload3rdAppState', params);
          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res);
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  getDownload3rdAppList: function getDownload3rdAppList() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", {
              result: []
            });
          case 1:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  setMoreInfo: function setMoreInfo(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", tvf_jsapi_default.a.invoke('setMoreInfo', params));
          case 1:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  setShare: function setShare(params, onShare, onShareSuccess) {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      var data;
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            data = yyb_objectSpread({
              shareInfo: {
                title: params.title,
                subTitle: params.desc,
                singleTitle: params.singleTitle,
                content: params.title,
                contentTail: params.desc,
                imageUrl: params.img,
                url: params.link,
                style: 1,
                picList: []
              }
            }, params);
            _this.onShare = onShare;
            _this.onShareSuccess = onShareSuccess;
            _context6.next = 5;
            return _this.setMoreInfo(data);
          case 5:
            _this.shareCallback();
          case 6:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  shareCallback: function shareCallback() {
    var _this2 = this;
    tvf_jsapi_default.a.on('onToolsDialogShow', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this2.onShare && _this2.onShare(res);
    });
    tvf_jsapi_default.a.on('onShareFinish', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this2$parse = _this2.parse(res),
        _this2$parse$errCode = _this2$parse.errCode,
        errCode = _this2$parse$errCode === void 0 ? '' : _this2$parse$errCode;
      if (Number(errCode) === 0) {
        _this2.onShareSuccess && _this2.onShareSuccess(res);
      }
    });
  },
  openToolsDialog: function openToolsDialog(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", tvf_jsapi_default.a.invoke('openToolsDialog', params));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  }
});
/* harmony default export */ var yyb = (yyb_api);
// CONCATENATED MODULE: ./src/bridge/libs/iwan.js



function iwan_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function iwan_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? iwan_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : iwan_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 爱玩app jsapi
 */


var iwan_api = iwan_objectSpread(iwan_objectSpread(iwan_objectSpread({}, app), video), {}, {
  /**
   * 向app端传递数据
   */
  setEventData: function setEventData(data) {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var res;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.callJSBridge('setEventData', data);
          case 2:
            res = _context.sent;
            return _context.abrupt("return", res);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
});
/* harmony default export */ var iwan = (iwan_api);
// CONCATENATED MODULE: ./src/bridge/commons/other.js


var other_common = {
  wakeApp: function wakeApp(opts, onSuccess, onFail) {
    var strScheme = opts.strScheme,
      _opts$timeout = opts.timeout,
      timeout = _opts$timeout === void 0 ? 2000 : _opts$timeout;
    var ios = Object(helper_["getPhoneSystem"])() === 'ios';

    // ios下直接通过url跳转 Scheme 拉起
    if (ios) {
      window.location.href = strScheme;
    } else {
      var e = document.createElement('iframe');
      e.style.cssText = 'width:1px;height:1px;position:fixed;top:0;left:0;opacity:0;';
      e.src = strScheme;
      document.body.appendChild(e);
    }
    var t = setTimeout(function () {
      onFail && onFail();
    }, timeout);
    window.onblur = function () {
      clearTimeout(t);
      onSuccess && onSuccess();
    };
  },
  downloadApp: function downloadApp(opts) {
    var os = Object(helper_["getPhoneSystem"])();
    var _opts$os = opts[os],
      downloadUrl = _opts$os.downloadUrl,
      params = _opts$os.params;
    window.location.href = "".concat(downloadUrl, "?").concat(Object(txv_utils_["encodeURIJson"])(params));
  }
};
/* harmony default export */ var other = (other_common);
// CONCATENATED MODULE: ./src/bridge/libs/wx.js



function wx_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function wx_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? wx_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : wx_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var wx_api = wx_objectSpread(wx_objectSpread({}, other), {}, {
  shareList: [{
    event: 'menu:share:appmessage',
    type: 'sendAppMessage'
  }, {
    event: 'menu:share:timeline',
    type: 'shareTimeline'
  }, {
    event: 'menu:share:qq',
    type: 'shareQQ'
  }, {
    event: 'menu:share:weiboApp',
    type: 'shareWeiboApp'
  }, {
    event: 'menu:share:QZone',
    type: 'shareQZone'
  }],
  check: function check() {
    return window.WeixinJSBridge && window.WeixinJSBridge.invoke && Object(txv_utils_["isFunction"])(window.WeixinJSBridge.invoke);
  },
  ready: function ready() {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              if (_this.check()) {
                resolve();
                return;
              }
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', resolve, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', resolve);
                document.attachEvent('onWeixinJSBridgeReady', resolve);
              }
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  wxSDKReady: function wxSDKReady() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              if (window.wx) {
                resolve();
              } else {
                Object(txv_utils_["loadScript"])('//res.wx.qq.com/open/js/jweixin-1.0.0.js', resolve);
              }
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  getInstallState: function getInstallState(config) {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this2.ready();
          case 2:
            return _context3.abrupt("return", new Promise(function (resolve) {
              window.WeixinJSBridge.invoke('getInstallState', config, function () {
                var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _res$err_msg = res.err_msg,
                  errMsg = _res$err_msg === void 0 ? '' : _res$err_msg;
                var result = errMsg.indexOf('get_install_state:yes') > -1;
                resolve(result);
              });
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  wakeApp: function wakeApp(opts, onSuccess, onFail) {
    var _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var version, _opts$wxAppID, wxAppID, _opts$strScheme, strScheme, rel;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            version = navigator.userAgent.match(/MicroMessenger\/(\d+\.\d+(\.\d+)?)/);
            _opts$wxAppID = opts.wxAppID, wxAppID = _opts$wxAppID === void 0 ? '' : _opts$wxAppID, _opts$strScheme = opts.strScheme, strScheme = _opts$strScheme === void 0 ? '' : _opts$strScheme;
            rel = Object(txv_utils_["versionCompare"])(version[1], '6.5.6');
            if (!(rel === -1)) {
              _context4.next = 6;
              break;
            }
            window.location.href = strScheme;
            return _context4.abrupt("return");
          case 6:
            _context4.next = 8;
            return _this3.ready();
          case 8:
            window.WeixinJSBridge.invoke('launchApplication', {
              parameter: strScheme,
              appID: wxAppID,
              extInfo: strScheme
            }, function () {
              var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var _res$err_msg2 = res.err_msg,
                errMsg = _res$err_msg2 === void 0 ? 'launchApplication:' : _res$err_msg2;
              var index = errMsg.lastIndexOf(':') + 1;
              var msg = errMsg.slice(index);
              if (msg === 'ok') {
                onSuccess && onSuccess();
              } else {
                onFail && onFail();
              }
            });
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  setShare: function setShare(params, onShare, onShareSuccess) {
    var _this4 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var data;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this4.ready();
          case 2:
            data = {
              // debug: true,
              wxAppID: params.wxAppID || '',
              title: params.title,
              desc: params.desc,
              img_url: params.img,
              link: params.link
            };
            return _context5.abrupt("return", new Promise(function (resolve) {
              var shareHandler = function shareHandler(type) {
                onShare && onShare({
                  type: type
                });
                if (type === 'shareTimeline' && params.singleTitle) {
                  data.title = params.singleTitle;
                }
                window.WeixinJSBridge.invoke(type, data, function () {
                  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  onShareSuccess && onShareSuccess({
                    type: type
                  });
                  resolve(res);
                });
              };
              _this4.shareList.forEach(function (item) {
                window.WeixinJSBridge.on(item.event, shareHandler.bind(null, item.type));
              });
            }));
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  }
});
/* harmony default export */ var wx = (wx_api);
// CONCATENATED MODULE: ./src/bridge/libs/qq.js



function qq_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function qq_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? qq_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : qq_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



var qq_api = qq_objectSpread(qq_objectSpread({}, other), {}, {
  /**
   * 判断安卓下是否有检测app安装状态的方法
   */
  hasAndroidApi: function hasAndroidApi() {
    return window.QQApi && Object(txv_utils_["isFunction"])(window.QQApi.checkAppInstalled);
  },
  /**
   * 判断ios下是否有检测app安装状态的方法
   */
  hasIosApi: function hasIosApi() {
    return window.mqq && window.mqq.app && Object(txv_utils_["isFunction"])(window.mqq.app.isAppInstalled);
  },
  check: function check() {
    return this.hasAndroidApi() || this.hasIosApi();
  },
  ready: function ready() {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              if (_this.check()) {
                resolve();
              } else {
                Object(txv_utils_["loadScript"])('//pub.idqqimg.com/qqmobile/qqapi.wk.js?_bid=152', resolve);
              }
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /**
   * @returns { Promise<*> }
   * @resolve { true | false }
   * 获取 app安装状态
   *
   * checkAppInstalled
   * 如果返回permission，需要去申请域名获取api的权限
   * res正常返回版本号, 0 表示未安装
   *
   * isAppInstalled 则直接返回 true | false
   */
  getInstallState: function getInstallState(config) {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var packageUrl, packageName, scheme;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this2.ready();
          case 2:
            packageUrl = config.packageUrl, packageName = config.packageName;
            scheme = Object(helper_["getPhoneSystem"])() === 'ios' ? packageUrl : packageName;
            return _context2.abrupt("return", new Promise(function (resolve) {
              if (_this2.hasAndroidApi()) {
                window.QQApi.checkAppInstalled(scheme, function (res) {
                  var result = !/denied|permission/.test(res) && res !== '0';
                  resolve(result);
                });
              } else if (_this2.hasIosApi()) {
                window.mqq.app.isAppInstalled(scheme, function (res) {
                  resolve(res);
                });
              } else {
                resolve(false);
              }
            }));
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  setShare: function setShare(params, onShare, onShareSuccess) {
    var _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this3.ready();
          case 2:
            if (window.mqq) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return");
          case 4:
            return _context3.abrupt("return", new Promise(function (resolve) {
              window.mqq.ui.setOnShareHandler(function (type) {
                onShare && onShare();
                window.mqq.ui.shareMessage({
                  title: params.title,
                  desc: params.desc,
                  share_type: type,
                  image_url: params.img,
                  share_url: params.link
                }, function () {
                  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  if (res && res.retCode === 0) {
                    onShareSuccess && onShareSuccess(res);
                  }
                  resolve();
                });

                // 安卓端shareMessage没有回调参数，所以直接返回分享成功
                if (Object(helper_["getPhoneSystem"])() === 'android') {
                  onShareSuccess && onShareSuccess();
                  resolve();
                }
              });
            }));
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  /**
  * 封装手机QQ jsapi openUrl的能力
  * @param url
  * @param target 0: 在当前webview打开 1: 在新webview打开 2: 在外部浏览器上打开（iOS为Safari,Android为系统默认浏览器）
  * @param style 0: 顶部标题栏模式（无底部工具栏） 1: 顶部标题栏无分享入口（无底部工具栏） 2: 底部工具栏模式（顶部标题依然会存在） 3: 底部工具栏模式且顶部无分享入口（顶部标题依然会存在）
  * @param animation 动画效果 0: 从右往左 1: 直接打开 2: 从下往上
  */
  mqqOpenUrl: function mqqOpenUrl(url) {
    var _arguments = arguments,
      _this4 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var target, style, animation;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            target = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : 2;
            style = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : 0;
            animation = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : 1;
            _context4.next = 5;
            return _this4.ready();
          case 5:
            if (!(!window.mqq || !url)) {
              _context4.next = 7;
              break;
            }
            return _context4.abrupt("return");
          case 7:
            return _context4.abrupt("return", new Promise(function (resolve) {
              window.mqq.ui.openUrl({
                url: url,
                target: target,
                style: style,
                animation: animation
              });
              resolve();
            }));
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  }
});
/* harmony default export */ var qq = (qq_api);
// CONCATENATED MODULE: ./src/bridge/libs/qqbrowser.js



function qqbrowser_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function qqbrowser_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? qqbrowser_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : qqbrowser_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var qqbrowser_api = qqbrowser_objectSpread(qqbrowser_objectSpread({}, other), {}, {
  check: function check() {
    return this.hasAndroidApi() || this.hasIosApi();
  },
  /**
   * 获取 qq浏览器 jsapi 是否ready
   */
  ready: function ready() {
    var _this = this;
    return new Promise(function (resolve) {
      if (_this.check()) {
        resolve();
      } else {
        Object(txv_utils_["loadScript"])('//res.imtt.qq.com/browser_lightapp/QQBrowserApi/getCryptext/browser_interface_getCryptext.js', resolve);
      }
    });
  },
  /**
   * 判断安卓下是否有检测app安装状态的方法
   */
  hasAndroidApi: function hasAndroidApi() {
    return window.x5mtt && Object(txv_utils_["isFunction"])(window.x5mtt.isApkInstalled);
  },
  /**
   * 判断ios下是否有检测app安装状态的方法
   */
  hasIosApi: function hasIosApi() {
    return window.x5 && window.x5.ios && Object(txv_utils_["isFunction"])(window.x5.ios.getMobileAppSupport);
  },
  /**
   * 获取 app安装状态
   */
  getInstallState: function getInstallState(config) {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var packageUrl, packageName;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this2.ready();
          case 2:
            packageUrl = config.packageUrl, packageName = config.packageName;
            return _context.abrupt("return", new Promise(function (resolve) {
              if (_this2.hasAndroidApi()) {
                var res = window.x5mtt.isApkInstalled("{\"packagename\": ".concat(packageName, "}"));
                resolve(res);
                return;
              }
              if (_this2.hasIosApi()) {
                window.x5.ios.getMobileAppSupport({
                  scheme: packageUrl
                }, function () {
                  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  var isSupportApp = res.isSupportApp;
                  resolve(isSupportApp);
                }, function () {
                  resolve(false);
                });
                return;
              }
              resolve(false);
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
});
/* harmony default export */ var qqbrowser = (qqbrowser_api);
// EXTERNAL MODULE: external "@tencent/iwan-biz-helper"
var iwan_biz_helper_ = __webpack_require__(19);

// EXTERNAL MODULE: external "@tencent/txv-athena/lib/variable"
var variable_ = __webpack_require__(10);

// CONCATENATED MODULE: ./src/bridge/libs/browser.js



function browser_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function browser_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? browser_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : browser_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 浏览器statistics
 * 返回数据格式与视频内statistics(tenvideo.js)保持一致
 */





var browserApi = browser_objectSpread(browser_objectSpread({}, other), {}, {
  // 封装成功数据返回
  handleSuccess: function handleSuccess() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      errCode: 0,
      errMsg: 'success',
      result: options.result || ''
    };
  },
  // 封装失败数据返回
  handleFail: function handleFail() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
      errCode: options.errCode || -1,
      errMsg: options.errMsg || 'fail',
      result: options.result || ''
    };
  },
  getDeviceInfo: function getDeviceInfo() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", browserApi.handleSuccess({
              result: {}
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  getAppInfo: function getAppInfo() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", browserApi.handleSuccess({
              result: {}
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  setShare: function setShare() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  },
  shareLocalImage: function shareLocalImage() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }))();
  },
  downloadApp: function downloadApp(opts) {
    var os = Object(helper_["getPhoneSystem"])();
    var _opts$os = opts[os],
      downloadUrl = _opts$os.downloadUrl,
      params = _opts$os.params;

    // 先尝试拉起，如果拉起失败，则尝试下载
    this.wakeApp(opts, function () {}, function () {
      window.location.href = "".concat(downloadUrl, "?").concat(Object(txv_utils_["encodeURIJson"])(params));
    });
  },
  // 登陆
  login: function login() {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee5() {
      var ruUrl, url;
      return regenerator_default.a.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            ruUrl = Object(txv_utils_["setUrlParams"])({
              code: ''
            });
            url = "https://iwan.qq.com/m/login/login-qt.htm?ru=".concat(encodeURIComponent(ruUrl));
            Object(iwan_biz_helper_["openPage"])(url);

            // user.login方法兼容了登录成功回调参数，若参数有刷新页面，没有sleep则会直接刷新而不跳转
            _context5.next = 5;
            return Object(txv_utils_["sleep"])(200);
          case 5:
            return _context5.abrupt("return", variable_["LOGIN_STATUS"].login);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }))();
  },
  // 退出
  logout: function logout() {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee6() {
      return regenerator_default.a.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _this.clearUserCookie();
            return _context6.abrupt("return", variable_["LOGIN_STATUS"].logout);
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }))();
  },
  /**
   * 为了和其它场景保持统一，获取不到安装状态，直接返回 false
   * 尝试失败后，直接会调用下载
   */
  getInstallState: function getInstallState() {
    return false;
  },
  clearUserCookie: function clearUserCookie() {
    var opts = {
      domain: 'iwan.qq.com'
    };
    var optqq = {
      domain: 'qq.com'
    };
    txv_utils_["cookie"].del(['appid', 'openid', 'access_token', 'main_login', 'vuserid', 'vusession', 'vqq_vuserid', 'vqq_vusession', 'open_appid', 'open_openid', 'open_access_token', 'vqq_appid', 'vqq_openid', 'vqq_access_token'], opts);
    txv_utils_["cookie"].del(['main_login', 'uin', 'skey', 'luin'], optqq);
  },
  openUrl: function openUrl() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      url: ''
    };
    var apiParams = {};
    if (Object(txv_utils_["isString"])(params)) {
      apiParams.url = params;
    } else {
      apiParams = params;
    }
    window.location.href = apiParams.url;
  },
  close: function close(backUrl) {
    if (backUrl) {
      window.location.replace(backUrl);
    } else {
      window.history.back();
    }
  },
  // 当前主登录状态，目前"qq"、"wx"两种以及未登录
  getMainLoginType: function getMainLoginType() {
    var _this2 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee7() {
      return regenerator_default.a.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (!Object(helper_["checkWX"])()) {
              _context7.next = 2;
              break;
            }
            return _context7.abrupt("return", _this2.handleSuccess({
              result: 'wx'
            }));
          case 2:
            if (!Object(helper_["checkQQ"])()) {
              _context7.next = 4;
              break;
            }
            return _context7.abrupt("return", _this2.handleSuccess({
              result: 'qq'
            }));
          case 4:
            return _context7.abrupt("return", _this2.handleSuccess({
              result: ''
            }));
          case 5:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }))();
  },
  /**
   * 获取当前主登录账号的cookie
   * 返回结果：res.result: {cookie: "uin=xx", type: "qq"}
   */
  getMainCookie: function getMainCookie() {
    var _this3 = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee8() {
      var mainLoginRes, mainLogin, result;
      return regenerator_default.a.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _this3.getMainLoginType();
          case 2:
            mainLoginRes = _context8.sent;
            if (mainLoginRes.result) {
              _context8.next = 5;
              break;
            }
            return _context8.abrupt("return", mainLoginRes);
          case 5:
            mainLogin = mainLoginRes.result;
            result = {
              type: mainLogin,
              cookie: {}
            };
            if (mainLogin === 'qq') {
              result.cookie = {
                uin: Object(helper_["formatQQ"])(txv_utils_["cookie"].get('uin')),
                skey: txv_utils_["cookie"].get('skey'),
                luin: txv_utils_["cookie"].get('luin'),
                lskey: txv_utils_["cookie"].get('lskey'),
                appid: txv_utils_["cookie"].get('open_appid') || txv_utils_["cookie"].get('vqq_appid'),
                openid: txv_utils_["cookie"].get('open_openid') || txv_utils_["cookie"].get('vqq_openid'),
                access_token: txv_utils_["cookie"].get('open_access_token') || txv_utils_["cookie"].get('vqq_access_token')
              };
            } else if (mainLogin === 'wx') {
              result.cookie = {
                appid: txv_utils_["cookie"].get('appid'),
                openid: txv_utils_["cookie"].get('openid'),
                access_token: txv_utils_["cookie"].get('access_token')
              };
            }
            return _context8.abrupt("return", _this3.handleSuccess({
              result: result
            }));
          case 9:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  },
  // 获取本地存储
  getNativeStorage: function getNativeStorage(key) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee9() {
      var result;
      return regenerator_default.a.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            result = txv_utils_["storage"].get(key);
            return _context9.abrupt("return", result);
          case 2:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }))();
  },
  // 设置本地存储
  setNativeStorage: function setNativeStorage(key, value) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee10() {
      return regenerator_default.a.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", txv_utils_["storage"].set(key, value));
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }))();
  }
});
/* harmony default export */ var browser = (browserApi);
// CONCATENATED MODULE: ./src/bridge/libs/bbg.js



function bbg_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function bbg_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? bbg_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bbg_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * BBG jsapi
 * 使用tvf-jsapi
 */


var bbg_api = bbg_objectSpread(bbg_objectSpread({}, app), {}, {
  // 调用app指定的api
  callJSBridge: function callJSBridge(strMethod, params) {
    return tvf_jsapi_default.a.invoke(strMethod, params);
  },
  on: function on() {
    var _tvfJsApi$on;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_tvfJsApi$on = tvf_jsapi_default.a.on).call.apply(_tvfJsApi$on, [tvf_jsapi_default.a].concat(args));
  },
  // 获取设备信息
  getDeviceInfo: function getDeviceInfo() {
    return tvf_jsapi_default.a.invoke('getDeviceInfo');
  },
  getMainCookie: function getMainCookie() {
    return tvf_jsapi_default.a.invoke('getMainCookie');
  },
  setMoreInfo: function setMoreInfo(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", tvf_jsapi_default.a.invoke('setMoreInfo', params));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  setShare: function setShare(params, onShare, onShareSuccess) {
    var _this = this;
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var data;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            data = bbg_objectSpread({
              shareInfo: {
                title: params.title,
                subTitle: params.desc,
                singleTitle: params.singleTitle,
                content: params.title,
                contentTail: params.desc,
                imageUrl: params.img,
                url: params.link,
                style: 1,
                picList: []
              }
            }, params);
            _this.onShare = onShare;
            _this.onShareSuccess = onShareSuccess;
            _context2.next = 5;
            return _this.setMoreInfo(data);
          case 5:
            _this.shareCallback();
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  shareCallback: function shareCallback() {
    var _this2 = this;
    tvf_jsapi_default.a.on('onToolsDialogShow', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _this2.onShare && _this2.onShare(res);
    });
    tvf_jsapi_default.a.on('onShareFinish', function () {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this2$parse = _this2.parse(res),
        _this2$parse$errCode = _this2$parse.errCode,
        errCode = _this2$parse$errCode === void 0 ? '' : _this2$parse$errCode;
      if (Number(errCode) === 0) {
        _this2.onShareSuccess && _this2.onShareSuccess(res);
      }
    });
  },
  openToolsDialog: function openToolsDialog(params) {
    return asyncToGenerator_default()(/*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", tvf_jsapi_default.a.invoke('openToolsDialog', params));
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
});
/* harmony default export */ var bbg = (bbg_api);
// CONCATENATED MODULE: ./src/bridge/index.js

function bridge_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function bridge_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? bridge_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bridge_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }













/**
 * atom 原子级的，指最小化的平台场景
 * atomPlatform （微信、qq、视频app、视频极速版app、爱玩app、qq浏览器、其它）
 * simplePlatform （视频app、视频极速版app、爱玩app、其它场景都按浏览器处理）
 */
var atomPlatform = Object(helper_["getPlatform"])();
var simplePlatform = Object(helper_["getPlatform"])(function (item) {
  return item.simple === 1;
});

/**
 * jsBridge 与 platform 的映射关系
 */
var bridgeMap = {
  tenvideo: tenvideo,
  lite: lite,
  iwan: iwan,
  wx: wx,
  qq: qq,
  weishi: weishi,
  sports: sports,
  yyb: yyb,
  qqbrowser: qqbrowser,
  browser: browser,
  bbg: bbg
};
var atomBridge = bridgeMap[atomPlatform];
var simpleBridge = bridgeMap[simplePlatform];
/* harmony default export */ var bridge = __webpack_exports__["default"] = (bridge_objectSpread(bridge_objectSpread({}, simpleBridge), atomBridge));

/***/ })

/******/ })["default"];